module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-featured.svg?08d3212ccd9e31f23cd0ee349e25ff1a";